export default "__VITE_ASSET__xKJbBQ4P__"